import { ModelCheckbox } from '@equifinance/shared';
import { formatDateTime } from '@equifinance/shared/utils';
import styled from 'styled-components';
import {
  Divider, InfoPanel, SubmitContainer, SubmittedText,
} from '../../components/UnderwriterDecision';
import {
  useChecklistContext,
} from '../../../../contexts';
import { ChecklistSection } from '../../ChecklistPage';
import { PaddedGenericSection } from '../GenericSection';
import SecurityCallSection from './Sections/SecurityCall';
import TitleDetailsSection from './Sections/TitleDetails';
import OfferSection from './Sections/Offer';
import DocumentsSection from './Sections/Documents';
import { FormSectionConfigurationAdapter } from './common';
import UnderwriterDecision from './Sections/UnderwriterDecision';

export const SendOfferRefName = 'send-offer';

const ButtonContainer = styled.div`
  width: fit-content;
`;

export default function SendOfferSection() {
  const { checklist } = useChecklistContext();

  const { sendOffer, errors, warnings } = checklist ?? {};
  const {
    checklistIndicatorType, submitted, submittedByName, submittedTimestamp, canSubmit, offer,
  } = sendOffer ?? {};

  return (
    <PaddedGenericSection
      refName={SendOfferRefName}
      section={ChecklistSection.SEND_OFFER}
      subSection={ChecklistSection.NOTES_SEND_OFFER}
      checklistItem={sendOffer}
      errors={errors}
      warnings={warnings}
    >
      <FormSectionConfigurationAdapter isSectionDisabled={submitted || !!offer?.status || checklistIndicatorType === 'Locked'}>
        <SecurityCallSection />
        <TitleDetailsSection />
      </FormSectionConfigurationAdapter>

      <FormSectionConfigurationAdapter isSectionDisabled={submitted || checklistIndicatorType === 'Locked'}>
        <OfferSection />
        <DocumentsSection />
      </FormSectionConfigurationAdapter>

      <UnderwriterDecision />

      <SubmitContainer>
        {submitted && submittedByName && submittedTimestamp && (
          <InfoPanel>
            <SubmittedText>
              {submittedByName}
            </SubmittedText>
            <Divider />
            <SubmittedText>
              {formatDateTime(submittedTimestamp, 'DD/MM/YYYY, HH:mm:ss')}
            </SubmittedText>
          </InfoPanel>
        )}
        <ButtonContainer>
          <ModelCheckbox
            label="Mark as complete"
            field="sendOffer.submitted"
            disabled={!canSubmit || checklistIndicatorType === 'Locked'}
            successColor={submitted}
            isCompleteCheckbox
          />
        </ButtonContainer>
      </SubmitContainer>
    </PaddedGenericSection>
  );
}
